
import React from "react";
export const KpiIcon = ({ name, size = 14, color = "currentColor", style: extraStyle, ...rest }) => {
  const paths = {
    add:     <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    edit:    <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>,
    copy:    <><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></>,
    note:    <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>,
    chat:    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>,
    audit:   <><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></>,
    assign:  <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
    history: <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    search:  <><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>,
    filter:  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>,
    chevron: <polyline points="6 9 12 15 18 9"/>,
    x:       <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
    check:   <polyline points="20 6 9 17 4 12"/>,
    upload:  <><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></>,
    location:<><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></>,
    dots:    <><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></>,
    export:  <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></>,
    trash:   <><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></>,
    n:       <path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5zm-5 0C8.67 10 8 9.33 8 8.5v-5C8 2.67 8.67 2 9.5 2S11 2.67 11 3.5v5c0 .83-.67 1.5-1.5 1.5z"/>,
    alert:   <><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></>,
    lock:    <><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
    unlock:  <><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/></>,
    calendar:<><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
    chart:   <><line x1="6" y1="20" x2="6" y2="14"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="18" y1="20" x2="18" y2="10"/></>,
    scale:   <><line x1="12" y1="3" x2="12" y2="21"/><line x1="5" y1="7" x2="19" y2="7"/><path d="M5 7l-2.5 6a3 3 0 0 0 5 0z"/><path d="M19 7l-2.5 6a3 3 0 0 0 5 0z"/></>,
    drop:    <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>,
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        display: "inline-block",
        flexShrink: 0,
        minWidth: size,
        minHeight: size,
        maxWidth: size,
        maxHeight: size,
        verticalAlign: "middle",
        ...extraStyle,
      }}
      {...rest}
    >
      {paths[name] ?? null}
    </svg>
  );
};

/**
 * Wraps matching substrings with a highlight <mark>.
 */
export const HighlightText = ({ text = "", query = "" }) => {
  if (!query.trim()) return <span>{text}</span>;
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = text.split(new RegExp(`(${escaped})`, "gi"));
  return (
    <span>
      {parts.map((part, i) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <mark key={i} className="kpi-search-mark">{part}</mark>
        ) : (
          part
        )
      )}
    </span>
  );
};

/**
 * Avatar circle with colour derived from id.
 */
export const Avatar = ({ id, name, size = 32 }) => {
  const colors = [
    "#2563eb","#16a34a","#dc2626","#d97706",
    "#7c3aed","#0891b2","#be185d","#0f766e",
  ];
  const hash = String(id).split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  const bg = colors[hash % colors.length];
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: bg, color: "#fff",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: size * 0.38, fontWeight: 700, flexShrink: 0,
      fontFamily: "var(--font-sans)",
    }}>
      {(name || "?").charAt(0).toUpperCase()}
    </div>
  );
};

export const KpiSpinner = ({ label = "Loading…" }) => (
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "56px 24px", gap: 12, color: "var(--ink-4)", fontFamily: "var(--font-sans)", fontSize: 13 }}>
    <div className="kpi-spinner" />
    {label}
  </div>
);

/** Compact "N docs" pill for a table cell — shared by the quantitative answer
 *  history row and the audit answer row, so both look and behave the same.
 *  Pass `onClick` to make it interactive (receives the filtered doc array). */
export const DocBadge = ({ docs, onClick }) => {
  const list = Array.isArray(docs) ? docs.filter(Boolean) : docs ? [docs] : [];
  const count = list.length;
  if (!count) return <span style={{ fontSize: 11, color: "var(--ink4)" }}>—</span>;
  return (
    <span
      onClick={onClick ? (e) => { e.stopPropagation(); onClick(list); } : undefined}
      style={{
        display: "inline-flex", alignItems: "center", gap: 4,
        padding: "2px 8px", borderRadius: 5,
        background: "var(--blue3)", color: "var(--blue)",
        fontSize: 11, fontWeight: 600, cursor: onClick ? "pointer" : "default",
      }}
    >
      <KpiIcon name="audit" size={10} color="var(--blue)" /> {count > 1 ? `${count} docs` : "doc"}
    </span>
  );
};

export const KpiModal = ({ show, onClose, children, maxWidth = 560 }) => {
  if (!show) return null;
  return (
    <div className="kpi-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="kpi-modal-box" style={{ maxWidth }}>
        {children}
      </div>
    </div>
  );
};

export const ModalHeader = ({ emoji, icon, title, subtitle, bg = "var(--surface-2)", borderColor = "var(--rule)", onClose, subtitleStyle = {}, titleStyle = {} }) => (
  <div style={{ padding: "20px 24px 16px", borderBottom: `1px solid ${borderColor}`, background: bg, flexShrink: 0 }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      {icon && (
        <div style={{
          width: 36, height: 36, borderRadius: 10, flexShrink: 0, marginRight: 12,
          background: "var(--accent-3)", border: "1.5px solid var(--accent-2)",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <KpiIcon name={icon} size={16} color="var(--accent)" />
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: subtitle ? 4 : 0 }}>
            {emoji && <span style={{ fontSize: 18 }}>{emoji}</span>}
            <span style={{ fontWeight: 800, fontSize: 16, color: "var(--ink)", fontFamily: "var(--font-sans)", ...titleStyle }}>{title}</span>
          </div>
        )}
        {subtitle && (
          <div style={{ fontSize: 11.5, color: "var(--ink-3)", fontFamily: "var(--font-mono)", marginLeft: emoji ? 26 : 0, maxWidth: 400, lineHeight: 1.4, ...subtitleStyle }}>
            {subtitle}
          </div>
        )}
      </div>
      {onClose && (
        <button onClick={onClose} style={{ border: "none", background: "transparent", fontSize: 22, cursor: "pointer", color: "var(--ink-3)", lineHeight: 1, padding: "0 0 0 12px", flexShrink: 0 }}>
          ×
        </button>
      )}
    </div>
  </div>
);